export default __webpack_public_path__ + "static/media/star.e7dad7b8.svg";